import React from 'react';
import {Table} from 'reactstrap';


const RingCentral = ({pageData = {}, pageObj,settings={}}) => {
    console.log(pageData)
    const getTableRow = () => {
        if (pageData.extension_list) {
            return pageData.extension_list.map((extension,index)=>
             
                <tr key={index}>
                    <td>{index + (pageObj.user_page * 10 - 9 )}</td>
                    <td>{extension.name}</td>
                    <td className="text-center align-middle">
                        {extension.extension_no}
                    </td>
                    <td className="text-center align-middle">
                        {extension.status}
                    </td>
                    <td className="text-center align-middle">
                        {extension.total_calls}
                    </td>
                    <td className="text-center align-middle">
                        {extension.inbound_calls}
                    </td>
                    <td className="text-center align-middle">
                        {extension.missed_percentage}
                    </td>
                </tr>
            );
        } 
        return [];
    }
    return (
        <div className="container-fluid my-1">
            <div className="col-md-12">
                {/* <div className="col-md-7 float-left text-right pr-5"> */}
                   <p className="text-center display-6 font-weight-bold">
                        {pageData && pageData.title && pageData.title}
                    </p> <span className="hor-bar"/> 
                    
                {/* </div> */}
                {/* <div className="float-right"> */}
                    <p className="float-right text-right display-6 font-weight-bold" style={{fontSize:'30px'}}>
                        {pageData && pageData.from_date && pageData.from_date} {pageData.from_date && '-'} {pageData && pageData.to_date && pageData.to_date}
                    </p>
                    {/* <span className="hor-bar"/> */}
                {/* </div> */}
            

            </div>
            <Table striped bordered size="sm" className="mb-0 mt-2 bg-white"
            >
                <thead className="bg-info font-30 text-white">
                    <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th className="text-center align-middle">Extension</th>
                        <th className="text-center align-middle">Status</th>
                        <th className="text-center align-middle">Total Calls</th>
                        <th className="text-center align-middle"># Inbound Calls</th>
                        <th className="text-center align-middle">% Missed (w/VM)</th>
                    </tr>
                </thead>
                <tbody className="font-24">
                    <tr/>
                    {getTableRow()}
                </tbody>
            </Table>
        </div>
    )
};
export default RingCentral;



// WEBPACK FOOTER //
// ./src/components/agencyMonitor/RingCentral.js